module.exports = __webpack_public_path__ + "static/hackathon-0629f73a7387d9fc823d39600ea75c24.jpg";